<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                    <ion-title>Manage Charger Installation / <span class="ion-sub-title">{{bayId}}</span> </ion-title>
                    <ion-buttons slot="end" v-if="viewmode && rightToUpdate">
                    <ion-button @click="editChargerInstall">
                        EDIT
                    </ion-button>
                </ion-buttons>
                </ion-buttons>
                <ion-buttons slot="end" v-if="viewmode">
                <ion-button @click="viewChargerDetails" v-if="!rightToUpdate">
                    View Charger Details
                </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ChargerInstallationDetail v-if="!viewmode" />
            <ChargerInstallationView v-if="viewmode" />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerInstallationDetail from "@/components/admin/ChargerInstallationDetail.vue";
import ChargerInstallationView from "@/components/admin/ChargerInstallationView.vue";
import { AppUtils } from "@/util/app-utils";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'chargerInstallationDetail',
    components: {
        ChargerInstallationDetail, ChargerInstallationView, IonHeader, IonToolbar, IonButtons, IonBackButton, IonContent
    },
    data() {
        return {
            rightToUpdate: false,
            viewmode: false,
            bayId: "New"
        }
    },
    async mounted() {
        this.rightToUpdate = new AppUtils().getUserAccess("40|U");
        if (this.$route.params.bayId) {
        if (this.$route.query.mode) {
            this.viewmode = false;
            this.bayId = "Edit";
        } else {
            this.viewmode = true;
            this.bayId = "Detail";
        }
        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        },
        editChargerInstall() {
            this.viewmode = false;
            this.bayId = "Edit";
        },
        viewChargerDetails() {
            // this.$router.push("/admin/chargers")
            this.$router.push({
                name: "chargerView",
                params: { chargerId: this.$route.params.stationId }
            });
        }
    }
})
</script>
